import {createFileRoute, Navigate, SearchSchemaInput, useNavigate} from "@tanstack/react-router"
import {Tile, TILE_ACTION_BUTTON_SX, TileSpread} from "../../../components/Tile.tsx";
import {ActionButton} from "../../../components/ActionButton.tsx";
import {useTranslation} from "react-i18next";
import {useAdmitMutation} from "../../../tq/tqx.tsx";
import {TruckCapsule} from "../../../truck/capsule.tsx";
import {
    faClockRotateLeft,
    faFolder,
    faHourglassStart,
    faPause,
    faTriangleExclamation,
    faTruckFast,
    faTruckFront,
    faTruckLoading,
    faWatch,
    IconDefinition
} from "@fortawesome/pro-regular-svg-icons";
import {Box, Button, Sheet, SheetProps, Stack, useTheme} from "@mui/joy";
import {FontAwesomeIcon, FontAwesomeIconProps} from "@fortawesome/react-fontawesome";
import {DECO_DELAY_SCENES, useDecoDecay} from "../../../dispatch/decay.tsx";
import {isBundleMochikomi} from "../../../bundle/bundle.tsx";
import {SuspenseDialog} from "../../../components/SuspenseDialog.tsx";
import {useCallback, useMemo, useState} from "react";
import {SceneIcon} from "../../../dispatch/DispatchTile.tsx";
import {RouterJoyLink} from "../../../link.tsx";
import {SortOrder} from "../../../rpc/webrpc-client.gen.ts";
import {z} from "zod/v4";
import {GateTruck, useGateTrucks} from "../../../agent/admitter.tsx";
import {cmpScenesNewestFirst, pointillize} from "../../../timeline/timeline.tsx";
import {TSTZ_NEGATIVE_INFINITY} from "../../../tstzspan.ts";
import {useSelf} from "../../../agent/useSelf.ts";
import {
    IconToggleSwitch,
    RingedToggleButton,
    RingedToggleButtonProps,
    ToggleBar
} from "../../../components/ToggleBar.tsx";
import {Comparator, invertComparator, makeCascadingComparator, makeTieredComparator} from "../../../util/arutil.tsx";
import {useBomb} from "../../../bomb/bomb.tsx";
import {sortOrderIcons} from "../../../tq/tqutil.tsx";
import {VenueOverviewTruckStatusCode} from "../../../venue/venueOverviewTruckStatusCode.tsx";
import {PageBody, PageHeader, PageShell} from "../../../routing/shell.tsx";
import {TopBar} from "../../../components/TopBar.tsx";
import {isDeepEqual} from "remeda";

// function admitterTruckTileCosmetics({truckStatus}: {
//     truckStatus: TruckStatus
// }): {
//     color: CardProps["color"], variant: CardProps["variant"],
//     actionButtonColor: CardProps["color"], actionButtonVariant: CardProps["variant"],
// } {
//     if (truckStatus.currentCrew.length < 1) {
//         return {
//             color: "neutral",
//             variant: "soft",
//             actionButtonColor: "success",
//             actionButtonVariant: "solid",
//         };
//     }
//     const tripleg = truckStatus.lastTripleg;
//     if (isTstzFinite(tripleg?.admitted)) {
//         if (truckStatus.canDepart) {
//             return {
//                 color: "warning",
//                 variant: "soft",
//                 actionButtonColor: "primary",
//                 actionButtonVariant: "solid",
//             };
//         } else {
//             return {
//                 color: "success",
//                 variant: "soft",
//                 actionButtonColor: "neutral",
//                 actionButtonVariant: "solid",
//             };
//         }
//     } else {
//         if (isTstzFinite(tripleg?.arrived)) {
//             return {
//                 color: "primary",
//                 variant: "solid",
//                 actionButtonVariant: "solid",
//                 actionButtonColor: "success",
//             };
//         } else {
//             return {
//                 color: "primary",
//                 variant: "soft",
//                 actionButtonVariant: "solid",
//                 actionButtonColor: "primary",
//             };
//         }
//     }
// }
//
// function AdmitterTruckTile(props: TruckTileProps) {
//     const {truck} = props;
//     const {data: truckStatus, isSuccess: isStatusSuccess}
//         = useTruckStatus({truckId: truck.id});
//     if (!isStatusSuccess) {
//         return null;
//     }
//     const {
//         color, variant,
//         actionButtonVariant, actionButtonColor
//     }
//         = admitterTruckTileCosmetics({truckStatus});
//     const actions = isTstzFinite(truckStatus.lastTripleg?.arrived)
//     && !isTstzFinite(truckStatus.lastTripleg?.admitted)
//         ? <CardActions>
//             <ArriveButton truckId={truck.id} depth="brief" sx={{fontSize: "xl", py: 1.2}}
//                           color={actionButtonColor} variant={actionButtonVariant}/>
//         </CardActions>
//         : null;
//     return <TruckTile truck={truck} color={color} variant={variant}
//                       actions={actions}/>
// }
//
// function InboundTruckTile(props: TruckTileProps) {
//     const {color: inColor, variant: inVariant} = props;
//     const color = inColor ?? "primary";
//     const variant = inVariant ?? "soft";
//
//     return <TruckTile color={color} variant={variant} {...props}/>
// }
//
//
// function IdleTruckTile(props: TruckTileProps) {
//     const {color: inColor, variant: inVariant} = props;
//     const color = inColor ?? "neutral";
//     const variant = inVariant ?? "soft";
//
//     return <TruckTile color={color} variant={variant} {...props}/>
// }
//

// function useTruckBundleCapsules({truckId, ...rest}: LimitedUseQueryOptions<{ truckId: string }>) {
//     const mama = useMothership();
//     const {data: openTransfersData}
//         = useRefreshableQuery({
//         ...watchOpenBundleTransfersForTruckTqo(mama, {truckId}),
//         ...rest
//     });
//     const openTransferStubs = openTransfersData?.transfers ?? NADA;
//     const {data: bxTransfers}
//         = useBundleExpandedTransfers({transferStubs: openTransferStubs});
//     return <>{(bxTransfers ?? []).map(bxTransfer => {
//         return <BundleCapsule bundle={bxTransfer.bundle} key={bxTransfer.bundle.id} linkify={true}/>;
//     })}</>;
// }

// function OffloadingTruckTile(props: TruckTileProps) {
//     const {truckStub: truckStub, color: inColor, variant: inVariant, ...rest} = props;
//     const truckId = truckStub.id;
//     const color = inColor ?? "success";
//     const variant = inVariant ?? "outlined";
//     const bundleCapsules = useTruckBundleCapsules({truckId});
//
//     return <Tile color={color} variant={variant} {...rest}
//                  Subject={(props) =>
//                      <TruckCapsule truck={truckStub} {...props}/>}>
//         {bundleCapsules}
//     </Tile>;
// }

// function WaitingTruckTile(props: TruckTileProps) {
//     const {truck, color: inColor, variant: inVariant} = props;
//     const color = inColor ?? "primary";
//     const variant = inVariant ?? "solid";
//
//     const actions = <CardActions>
//         <ArriveButton truckId={truck.id} depth="brief" sx={{fontSize: "xl", py: 1.2}}
//                       color={color} variant="soft"/>
//     </CardActions>
//
//     return <TruckTile color={color} variant={variant} actions={actions} {...props}/>
// }

// interface GateTileProps {
//     transfer: BundleTransfer;
//     tripleg: Tripleg;
// }

// function MochikomiTransferTile({transfer}: { transfer: BundleTransfer }) {
//     const truck = transfer.truck;
//     const truckId = transfer.truck?.id ?? TQDEADBEEF;
//     const navigate = useNavigate();
//     const {t} = useTranslation();
//     const {mutateAsync: sendAdmit} = useAdmitMutation();
//     const bundleCapsules = useTruckBundleCapsules({truckId, enabled: truckId !== TQDEADBEEF});
//     const mama = useMothership();
//     const {data: triplegData} = useQuery({
//         ...watchLastTriplegForTruckTqo(mama, {truckId}),
//         enabled: truckId !== TQDEADBEEF
//     });
//     const tripleg = triplegData?.tripleg;
//     const triplegId = tripleg?.id ?? TQDEADBEEF;
//     const color = "tertiary";
//     const variant = "soft";
//     const actions = triplegId === TQDEADBEEF
//         ? null
//         : <>
//             <ActionButton color={color} variant="solid" disabled={!tripleg}
//                           size="lg" sx={TILE_ACTION_BUTTON_SX}
//                           perform={() => {
//                               return sendAdmit({triplegId}).then(() => navigate({
//                                   to: "/bundle/$id/cargo",
//                                   params: {id: transfer.bundleId},
//                               }));
//                           }}>{t("driver.startOnloading")}</ActionButton>
//         </>;
//
//     if (!truck) {
//         console.log(`no truck for transfer ${transfer.id}`);
//         return null;
//     }
//
//     return <Tile color={color} variant={variant}
//                  Subject={(props) =>
//                      <TruckCapsule truck={transfer.truck} {...props}/>} actions={actions}>
//         {bundleCapsules}
//     </Tile>
// }

// interface JishaAdmitTileProps {
//     tripleg: Tripleg;
// }
//
// function JishaAdmitTile({tripleg}: JishaAdmitTileProps) {
//     const {t} = useTranslation();
//     const {mutateAsync: sendAdmit} = useAdmitMutation();
//     let color: TileProps["color"] = "primary";
//     let variant: TileProps["variant"] = "outlined";
//     let actions: ReactNode;
//     const bundleCapsules = useTruckBundleCapsules({
//         truckId: tripleg.truck.id,
//         enabled: !tripleg.admitted,
//     });
//     const {data: crewPresences} = useTruckCrewPresences({
//         truckId: tripleg.truck.id,
//         enabled: !tripleg.admitted
//     });
//     const crewCapsules = (crewPresences ?? []).map(presence =>
//         <AgentPresenceCapsule presence={presence} key={presence.agent.id} icon={{icon: faSteeringWheel}}/>);
//
//     if (tripleg.admitted) {
//         color = "success";
//         variant = "soft";
//
// //        return <TruckTile truck={tripleg.truck} color={color} variant={variant} {...rest}/>
//     } else if (tripleg.arrived) {
//         color = "primary";
//         variant = "soft";
//         actions = <>
//             <ActionButton color={color} variant="solid" disabled={!tripleg}
//                           size="lg" sx={TILE_ACTION_BUTTON_SX}
//                           perform={() => sendAdmit({triplegId: tripleg.id})}>{t("driver.admit")}</ActionButton>
//         </>;
//
//         // return <TruckTile truck={tripleg.truck} color={color} variant={variant} actions={actions}
//         //                   showBundles={true} showDriver={true} {...rest}/>
//     }
//
//     return <Tile color={color} variant={variant}
//                  Subject={(props) =>
//                      <TruckCapsule truck={tripleg.truck} {...props}/>}
//                  actions={actions}>
//         {bundleCapsules}
//         {crewCapsules}
//     </Tile>;
//
//
//     // else {
//     //     const color = "primary";
//     //     const variant = "outlined";
//     //
//     //     return <TruckTile truck={tripleg.truck} color={color} variant={variant}
//     //                       showBundles={true} showDriver={true} {...rest}/>
//     // }
// }

// function OpenTransferTile({transfer, tripleg}: { transfer: BundleTransfer, tripleg: Tripleg }) {
//     const mama = useMothership();
//     const {data: bundleData} = useQuery(watchBundleByIdTqo(mama, {bundleId: transfer.bundleId}))
//     const jobStub = bundleData?.bundle?.job;
//     const jobId = jobStub?.id ?? TQDEADBEEF;
//     const {data: jobData} = useQuery({
//         ...peekJobByIdTqo(mama, {jobId}),
//         enabled: jobId !== TQDEADBEEF
//     });
//     const job = jobData?.job;
//
//     if (!job) {
//         return null;
//     }
//     if (job.jobCode) {
//         return <JishaAdmitTile tripleg={tripleg}/>;
//     } else {
//         return <MochikomiTransferTile transfer={transfer}/>;
//     }
// }

// function GateTile({vxt, venueId}: { vxt: VenueOverviewTruck, venueId: string }) {
//     const mama = useMothership();
//     const truckId = vxt.stub.id;
//     // TODO what to do with more than one transfer open here on a given truck?
//     const {data: truckOpenTransferStubsData} = useQuery(watchOpenBundleTransfersForTruckTqo(mama, {truckId}));
//     const truckOpenTransferStubs = truckOpenTransferStubsData?.transfers;
//     const truckOpenTransfers = useQueries({queries: (truckOpenTransferStubs ?? []).map(stub => watchBundleTransferByIdTqo(mama, {transferId: stub.id}))});
//     const relevantTransfer = truckOpenTransfers.find(maybe =>
//         maybe.data?.transfer ? isTransferRelevant({transfer: maybe.data.transfer, venueId}) : false)?.data?.transfer;
//
//     if (relevantTransfer) {
//         if (vxt.lastTripleg) {
//             return <OpenTransferTile transfer={relevantTransfer} tripleg={vxt.lastTripleg}/>
//         } else {
//             return <OffloadingTruckTile truckStub={vxt.stub}/>
//         }
//     } else {
//         if (vxt.lastTripleg) {
//             return <JishaAdmitTile tripleg={vxt.lastTripleg}/>;
//         } else {
//             return null;
//         }
//     }
// }

interface GateTileCosmetics {
    color: SheetProps["color"];
    icon: FontAwesomeIconProps;
}

const fallbackTileCosmetics: GateTileCosmetics =
    {color: "danger", icon: {icon: faTriangleExclamation}} as const;

const gateTileTruckCosmeticsByStatus: Record<VenueOverviewTruckStatusCode, GateTileCosmetics> = {
    awaitingAdmission: {color: "warning", icon: {icon: faHourglassStart}},
    departed: {color: "neutral", icon: {icon: faTruckFast, flip: "horizontal"}},
    inbound: {color: "success", icon: {icon: faTruckFast}},
    unknown: fallbackTileCosmetics,
    waitingToWork: {color: "warning", icon: {icon: faPause}},
    working: {color: "primary", icon: {icon: faTruckLoading}},
    idle: {color: "neutral", icon: {icon: faTruckFront}},
} as const;

function getGateTileCosmeticsForTruck(vxt: GateTruck): GateTileCosmetics | undefined {
    let rv = gateTileTruckCosmeticsByStatus[vxt.statusCode];
    if ([...vxt.activeTransfersHere, ...vxt.possibleTransfersHere].some(maybe =>
        isBundleMochikomi(maybe.bundle))) {
        rv = {...rv, color: "tertiary"};
    }
    return rv;
}

function GateTruckTile({vxt}: { vxt: GateTruck }) {
    const {t} = useTranslation();
    const theme = useTheme();
    const navigate = useNavigate();
    const cosmetics = getGateTileCosmeticsForTruck(vxt);
    const lastUpdated = vxt.lastScene?.when
        ? pointillize(vxt.lastScene.when).at
        : TSTZ_NEGATIVE_INFINITY;
    const {variant} = useDecoDecay({scenes: DECO_DELAY_SCENES, lastUpdated});
    const {mutateAsync: sendAdmit} = useAdmitMutation();

    const mochikomiBundle = [...vxt.activeTransfersHere, ...vxt.possibleTransfersHere]
        .find(maybe => isBundleMochikomi(maybe.bundle))?.bundle;

    let action = null;
    if (vxt.statusCode === "awaitingAdmission") {
        const perform = mochikomiBundle
            ? () => sendAdmit({triplegId: vxt.lastTripleg!.id})
                .then(() => navigate({
                    to: "/bundle/$id/cargo",
                    params: {id: mochikomiBundle.id},
                }))
            : () => sendAdmit({triplegId: vxt.lastTripleg!.id});
        action = <ActionButton color="primary" variant="solid" disabled={!vxt.lastTripleg}
                               size="lg" sx={TILE_ACTION_BUTTON_SX}
                               perform={perform}>
            {t("driver.admit")}
        </ActionButton>;
    }

    return <Tile color={cosmetics?.color} variant="outlined"
                 Subject={(props) =>
                     <RouterJoyLink to="/truck/$id/cargo" params={{id: vxt.stub.id}} color={cosmetics?.color}>
                         <TruckCapsule truck={vxt.stub} {...props}/>
                     </RouterJoyLink>}>
        <Stack direction="column" sx={{alignItems: "center"}}>
            <Stack direction="row" sx={{width: "95%"}}>
                <Stack direction="column" sx={{flex: 1, justifyContent: "center"}}>
                    <Box>{vxt.lastTripleg?.origin?.displayName ?? t("unknown")}</Box>
                </Stack>
                <Box>{t("venue.from")}</Box>
            </Stack>

            <Sheet color={cosmetics?.color} variant={variant}/>
            <Stack direction="column" sx={{alignItems: "center"}}>
                <Box sx={{fontSize: theme.fontSize.xl}}>{t(`venue.gate.statusLabel.${vxt.statusCode}`)}</Box>
                {cosmetics?.icon ? <SceneIcon icon={cosmetics.icon}/> : null}
            </Stack>

            {action}
        </Stack>
    </Tile>
}

const ActiveOrTiered = z.enum(["active", "tiered"]);
type ActiveOrTiered = z.infer<typeof ActiveOrTiered>;

const activeTieredIcons: Record<ActiveOrTiered, IconDefinition> = {
    active: faWatch,
    tiered: faFolder,
} as const;

const GateOverviewSettings = z.object({
    order: ActiveOrTiered,
    sortOrder: SortOrder,
});
type GateOverviewSettings = z.infer<typeof GateOverviewSettings>;

// const cmpGateTrucksByTier = makeTieredComparator({
//     tiers: [
//         "awaitingAdmission",
//         "inbound",
//         "waitingToWork",
//         "working",
//         "departed",
//         "idle",
//         "unknown",
//     ],
//     extractTier: (from: GateTruck) => from.statusCode,
// });
//
// const cmpGateTrucksByTierThenNewestFirst = makeCascadingComparator([
//     cmpGateTrucksByTier,
//     cmpGateTrucksByLastSceneNewestFirst,
// ]);

function validateGateSettings(raw?: Record<string, unknown> & SearchSchemaInput): GateOverviewSettings {
    const maybe = {order: "active", sortOrder: SortOrder.enum.DESC, ...raw};
    return GateOverviewSettings.parse(maybe);
}

function cmpGateTrucksByLastSceneNewestFirst(a: GateTruck, b: GateTruck) {
    return cmpScenesNewestFirst(a.lastScene, b.lastScene);
}

// if something is omitted from standardWatchedTiers entirely, as opposed to
// just being false, then it cannot be selected even if desired and does
// not show up in the top button area

const standardWatchedTiers = new Map<VenueOverviewTruckStatusCode, boolean>([
    ["awaitingAdmission", true],
    ["inbound", true],
    // ["waitingToWork", true],
    // ["working", true],
    // ["departed", false],
]);

function VenueGatePage() {
    const {id: venueId} = Route.useParams();
    const {data: self} = useSelf();
    const {t} = useTranslation();
    //const mama = useMothership();
    const navigate = useNavigate();
    const bomb = useBomb();
    const search = Route.useSearch();
    const order = search.order;
    const setOrder = useCallback((next: ActiveOrTiered) => {
        navigate({to: Route.to, params: {id: venueId}, search: {...search, order: next}}).catch(bomb);
    }, [bomb, navigate, search, venueId]);
    const sortOrder = search.sortOrder;
    const setSortOrder = useCallback((next: SortOrder) => {
        navigate({to: Route.to, params: {id: venueId}, search: {...search, sortOrder: next}}).catch(bomb);
    }, [bomb, navigate, search, venueId]);
    const vxtqrv = useGateTrucks({venueId});

    const [watchedTiers, setWatchedTiers] = useState(new Map<VenueOverviewTruckStatusCode, boolean>(standardWatchedTiers));
    const resetWatchedTiers = useCallback(() => {
        setWatchedTiers(new Map(standardWatchedTiers));
    }, []);
    const toggleTierWatchers = useMemo(() => {
        const standardWatchedTierNames = Array.from(standardWatchedTiers.keys());
        return new Map(
            standardWatchedTierNames.map(tier => {
                const rv: RingedToggleButtonProps["onChange"] = (_, value) => {
                    const next = new Map(watchedTiers);
                    next.set(tier, value);
                    setWatchedTiers(next);
                };
                return [tier, rv];
            }));
    }, [watchedTiers]);

    const isRelevant = useCallback((maybe: GateTruck) => {
        const rv = watchedTiers.get(maybe.statusCode);
        return !!rv;
    }, [watchedTiers]);

    const tierButtons = useMemo(() => {
        const watchedTierNames = Array.from(watchedTiers.keys());
        return <>{watchedTierNames.map(tier => {
            const cosmetics = gateTileTruckCosmeticsByStatus[tier];

            return <RingedToggleButton key={tier} value={tier}
                                       selected={watchedTiers.get(tier)}
                                       onChange={toggleTierWatchers.get(tier)}
                                       size="lg" color={cosmetics.color}>
                {<Stack direction="column" sx={{display: "flex", height: "100%"}}>
                    <Box sx={{flex: 0}}><FontAwesomeIcon {...cosmetics.icon} /></Box>
                    <Box sx={{flex: 1}}/>
                    <Box sx={{flex: 1}}>{t(`venue.gate.statusLabel.${tier}`)}</Box>
                </Stack>}
            </RingedToggleButton>
        })}</>;
    }, [t, toggleTierWatchers, watchedTiers]);

    const watchedTrucks = vxtqrv.data?.filter(isRelevant);

    const cmpByTier = useMemo(() =>
        makeCascadingComparator([
            makeTieredComparator({
                tiers: Array.from(watchedTiers.keys()),
                extractTier: (from: GateTruck) => from.statusCode,
            }),
            cmpGateTrucksByLastSceneNewestFirst]), [watchedTiers]);

    const cmp = useMemo(() => {
        let rv: Comparator<GateTruck> =
            order === "tiered" ? cmpByTier : cmpGateTrucksByLastSceneNewestFirst;
        if (sortOrder === SortOrder.enum.ASC) {
            rv = invertComparator(rv);
        }
        return rv;
    }, [cmpByTier, order, sortOrder]);

    const sortedVxts = useMemo(() => {
        const rv = (watchedTrucks ?? []).toSorted(cmp);
        return rv;
    }, [cmp, watchedTrucks]);

    // const vxts = useVenueTruckOrdering(cmp) ?? [];

    // useWhatChanged([vxts]);

    // const mama = useMothership();
    // const {data: inboundTriplegStubData}
    //     = useRefreshableQuery(watchUnadmittedTriplegsIntoTqo(mama, {venueId}));
    // const {data: openTransfersStubData}
    //     = useRefreshableQuery(watchOpenBundleTransfersAtVenueTqo(mama, {venueId}));
    //
    // const inboundTriplegStubs = inboundTriplegStubData?.triplegs ?? NADA;
    // const openTransferStubs = openTransfersStubData?.transfers ?? NADA;
    //
    // const {data: inboundTriplegs} = useQueries({
    //     queries: inboundTriplegStubs.map(stub => watchTriplegByIdTqo(mama, {triplegId: stub.id})),
    //     combine: useMappingMergeUseQueryResultCombiner(
    //         rpc => rpc.tripleg),
    // });
    // const {data: openTransfers} = useQueries({
    //     queries: openTransferStubs.map(stub => watchBundleTransferByIdTqo(mama, {transferId: stub.id})),
    //     combine: useMappingMergeUseQueryResultCombiner(
    //         rpc => rpc.transfer),
    // });
    //
    // // TODO: allow gradual popin?
    // const tileFoods = useMemo(() => {
    //     const transfersByTruck = new Map<string, BundleTransfer>();
    //     for (const transfer of openTransfers ?? []) {
    //         if (transfer.truck) {
    //             transfersByTruck.set(transfer.truck.id, transfer);
    //         }
    //     }
    //     const triplegsByTruck = new Map<string, Tripleg>();
    //     for (const tripleg of inboundTriplegs ?? []) {
    //         triplegsByTruck.set(tripleg.truck.id, tripleg);
    //     }
    //     const rv: Partial<GateTileProps>[] = [];
    //
    //     for (const transfer of openTransfers ?? []) {
    //         if (transfer.truck) {
    //             rv.push({transfer, tripleg: triplegsByTruck.get(transfer.truck.id)});
    //         }
    //     }
    //
    //     for (const tripleg of inboundTriplegs ?? []) {
    //         if (!transfersByTruck.has(tripleg.truck.id)) {
    //             rv.push({tripleg});
    //         }
    //     }
    //
    //     return rv;
    // }, [inboundTriplegs, openTransfers]);

    // if (!isInboundTriplegsSuccess) {
    //     return <SuspenseDialog message="inbound triplegs"/>
    // }
    // if (!isOpenTransfersSuccess) {
    //     return <SuspenseDialog message="open transfers"/>
    // }

    if (!self) {
        return <SuspenseDialog message="finding self"/>
    }
    if (self.admitterFor?.id !== venueId) {
        return <Navigate to="/"/>
    }

    //
    // switch (meshBootTemp) {
    //     case "cold":
    //         return <SuspenseDialog message="dispatch mesh cold"/>;
    //     case "warm":
    //         return <SuspenseDialog message="dispatch mesh assembling..."/>;
    //     case "dead":
    //         return <Death/>;
    //     case "hot":
    //         return <Stack direction="column">
    //             <ToggleBar>
    //                 <IconToggleSwitch dispatchValue={setOrder} icons={activeTieredIcons} value={order}/>
    //                 <IconToggleSwitch dispatchValue={setSortOrder} icons={sortOrderIcons} value={sortOrder}/>
    //             </ToggleBar>
    //             <GateTruckSpread cmp={cmp}/>
    //         </Stack>;
    // }

    return <PageShell>
        <PageHeader>
            <Stack direction="column">
                <TopBar/>

                <ToggleBar>
                    <IconToggleSwitch dispatchValue={setOrder} icons={activeTieredIcons} value={order}
                                      disabled={sortedVxts.length < 2}/>
                    <Stack direction="row"
                           sx={{padding: 0.8}}>
                        {tierButtons}

                        <Button color="primary" variant="solid" sx={{px: 1}}
                                onClick={resetWatchedTiers} disabled={isDeepEqual(watchedTiers, standardWatchedTiers)}>
                            <FontAwesomeIcon icon={faClockRotateLeft} size="2x"/>
                        </Button>
                    </Stack>

                    <IconToggleSwitch dispatchValue={setSortOrder} icons={sortOrderIcons} value={sortOrder}
                                      disabled={sortedVxts.length < 2}/>
                </ToggleBar>
            </Stack>
        </PageHeader>
        <PageBody>
            <TileSpread foods={sortedVxts} estimatedHeight={200}
                        Component={({food}) =>
                            <GateTruckTile vxt={food}/>}/>
        </PageBody>
    </PageShell>;
}

export const Route = createFileRoute("/_auth/venue/$id/gate")({
    component: VenueGatePage,
    validateSearch: validateGateSettings,
});

